import React from "react";
import { withRedux } from "helpers";
import {
  LeftNav,
  EditApp,
  EditTemplate,
  Input,
  Permissions,
  InviteUser,
  HasPermission,
} from "components";
// import { EditTemplate } from "components/Editor/EditTemplate/index.js";
//app/components/Editor/EditTemplate/
import AppView from "components/AppView";
import * as styles from "./home.styles";
import { Analytics, NotificationCenter } from "pages";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { remove } from "lodash";
import { removeInvoices } from "../../redux/actions";

class Home extends React.Component {
  componentDidMount() {
    const {
      activeApp: { id: appId },
      activeTemplate: { id: templateId },
      actions: {
        getDeals,
        getRewards,
        getPunchCards,
        getStoreItems,
        getStoreSettings,
        getCoupons,
        getInvoicesMetadataForApp,
        removeCoupons,
        removeInvoices,
        removeDeals,
        removeRewards,
        removePunchCards,
        removeStoreSettings,
        resetDisplay,
        resetOtherThanApps,
        removeStoreItems,
      },
    } = this.props;
    // console.log(this.props.activeApp);

    // reset everything before rendering the page
    removeDeals();
    removeCoupons();
    removeInvoices();
    removeRewards();
    removePunchCards();
    removeStoreItems();
    removeStoreSettings();
    resetDisplay();
    resetOtherThanApps();

    // fetching deals and rewards here to basically preload deals
    getCoupons(appId);
    getDeals(appId);
    getRewards(appId);
    getPunchCards(appId);
    getStoreSettings(appId);
    getInvoicesMetadataForApp(appId);

    // getStoreItems(appId, templateId);
    // console.log(this.props);
  }

  isAtHome = () => {
    return !this.props.activeTemplate;
  };
  clearTemplate = () => {
    const { activeApp } = this.props;
    this.props.actions.setTemplate(activeApp.id, null);
  };

  isAtDeal = () => {
    return this.props.activeTemplate.type === "deals";
  };
  isAtWebsite = () => {
    // console.log("!!!! at website! rendering appview");
    return this.props.activeTemplate.type === "website";
  };

  shouldDisplayForm = () => {
    const { activeTemplate, activeEditor } = this.props;
    if (this.isAtHome()) return false;
    if (this.isAtWebsite()) return false;
    // We want to always display bottom form for these template types
    if (
      [
        "aboutUs",
        "deals",
        "website",
        "rewards",
        "pictureCatalog",
        "store",
      ].includes(activeTemplate.type)
    ) {
      return true;
    } else if (activeEditor !== null) {
      // don't display form if no editor is selected
      return true;
    }
    return false;
  };

  editorController = () => {
    const {
      activeEditor,
      activeTemplate: { pageName, type },
      platformInfo: {
        display,
        status: {
          user: { id: userId },
        },
      },
    } = this.props;
    if (display.view === "Analytics" || display.view === "PurchaseHistory") {
      return (
        <div
          style={{
            width: "100%",
            margin: "40px 0px",
            height: "100vh",
          }}
        >
          <Analytics history={this.props.history} userId={userId} />
        </div>
      );
    }

    const nonTemplatePage = homeRouter[display.view];

    if (nonTemplatePage)
      return (
        <div
          style={{
            width: "100%",
            margin: "40px 0px",
            height: "100vh",
          }}
        >
          {nonTemplatePage}
        </div>
      );
    if (this.isAtHome()) {
      return (
        <HasPermission
          permission={2}
          fallback={<p>You don’t have permissions to edit this application.</p>}
        >
          <EditApp history={this.props.history} />
        </HasPermission>
      );
    }
    return (
      <div>
        <div
          style={{
            width: "675px",
            overflowY: "scroll",
            height: "90vh",
            paddingRight: "1em",
            backgroundColor: "white",
            paddingLeft: "3em",
            position: "relative",
            zIndex: "20",
            borderRight: "1px solid rgb(100 121 143 / 12%)",
          }}
        >
          {!this.isAtHome() && (
            <div>
              <FontAwesomeIcon
                style={{
                  fontSize: "1.75em",
                  cursor: "pointer",
                  display: "flex",
                  alignSelf: "flex-end",
                  marginTop: "10px",
                  marginBottom: "10px",
                  color: "#5f6368",
                }}
                icon="arrow-left"
                onClick={this.clearTemplate}
              />{" "}
            </div>
          )}
          <EditTemplate className="editTemplate" />
        </div>
        <AppView scale="0.8" top="2em" id="appView" />
      </div>
    );
  };

  render() {
    if (!this.props.activeApp.id) this.props.history.push("/lobby");

    return (
      <div
        style={{
          display: "flex",
          // backgroundColor: this.shouldDisplayForm()
          //   ? "rgba(0, 0, 0, 0.075)"
          //   : "white",
          // overflow: "scroll",
          // justifyContent: "center",
        }}
      >
        {this.isAtHome() && <LeftNav history={this.props.history} />}

        {this.editorController()}
      </div>
    );
  }
}

const homeRouter = {
  NotificationCenter: <NotificationCenter />,
  // Analytics: <Analytics />,
  Permissions: <Permissions />,
  InviteUser: <InviteUser />,
};

export default withRedux(Home);
